<template>
  <div class="main_center">
    <div class="search-content">
        <!-- <div class="mainBtn">
          <el-button
            @click="addNew()"
            size="small"
            type="primary"
            v-if="hasBtnPermission('main_credit_punish_add')"
          >新增联合惩戒信息</el-button>
          <el-button
            @click="deleteSelectItem()"
            size="small"
            v-if="hasBtnPermission('main_credit_punish_delete')"
          >删除</el-button>
        </div>-->
        <div class="pageTitle">信用报告</div>
        <div class="rightBoxInfo">
            <div class="searchBtn">
            <span class="label-form">关键字搜索：</span>
          <el-input
            @keyup.enter.native="searchBtn"
            clearable
            placeholder="请输入主体名称/代码"
            style="width: 300px"
            v-model="form.keywords"
          ></el-input>
          <el-button @click="searchBtn" size="small" type="primary" class="height_four">搜索</el-button>
          <el-button
            @click="moreSearchItem = true"
            icon="el-icon-arrow-down"
            size="mini"
            type="text"
            class="height_four"
          >更多搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
          </div>
        <div class="right_carousel">
          <el-carousel
            trigger="click"
            style="width:270px;height:64px"
            indicator-position="none"
            arrow="never"
            :interval="5000"
          >
            <el-carousel-item>
              <span class="small_item">本年累计下载报告：{{ this.downloadObj.yearCount }}份</span>
            </el-carousel-item>
            <el-carousel-item>
              <span class="small_item">历史累计下载报告：{{  this.downloadObj.count }}份</span>
            </el-carousel-item>
          </el-carousel>
        </div>
        </div>
      </div>
    <div class="content" >
      <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="form" label-position="top" ref="form">
            <el-form-item label="关键字搜索：">
              <el-input clearable placeholder="主体名称/代码" v-model="form.keywords"></el-input>
            </el-form-item>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="searchBtn" size="small" type="primary">搜索</el-button>
            <el-button @click="refresh" plain size="small">刷新</el-button>
          </div>
        </div>
      </searchBox>
   
      <el-table
        :header-cell-style="this.$globalGrayTableHeaderStyle"
        :height="tableMaxHeight"
        :data="tableData"
        border
        class="table-content"
        ref="multipleTable"
        stripe
        @selection-change="handleSelectionChange"
        @sort-change="sortChange"
        @filter-change="filterChange"
        v-loading="dataListLoading"
        @select-all="selectAll"
      >
        <!-- <el-table-column
          align="left"
          fixed
          type="selection"
          :selectable="checkSelectable"
          v-if="hasBtnPermission('main_credit_punish_delete')"
        ></el-table-column>-->
        <el-table-column
          :index="indexMethod"
          :show-overflow-tooltip="true"
          align="center"
          fixed
          label="序号"
          type="index"
          width="50"
        ></el-table-column>
        <!-- 正常 -->
        <el-table-column
          :filters="statusFilters"
          align="center"
          fixed
          label="状态"
          prop="entStatus"
          width="100"
        >
          <template slot-scope="scope">
            <i :class="formatterStatusClass(scope.row.entStatus)"></i>
            <span>{{formatterStatusName(scope.row.entStatus)}}</span>
          </template>
        </el-table-column>
        <!-- 法人 -->
        <el-table-column
          :filters="subjectTypeFilters"
          :show-overflow-tooltip="true"
          align="left"
          fixed
          header-align="center"
          label="主体大类"
          prop="roleTypeVal"
          width="100"
        >
          <template slot-scope>
            <span>法人</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          fixed
          header-align="center"
          label="主体名称"
          min-width="180"
          prop="mainName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          label="主体代码"
          min-width="180"
          prop="mainCode"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          label="交易主体类型"
          min-width="180"
          prop="roleTypeVal"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          label="入库时间"
          min-width="180"
          prop="firstNormalTime"
        >
          <template slot-scope="scope">
            <span>{{scope.row.firstNormalTime?scope.row.firstNormalTime:'---'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          label="修改人"
          min-width="140"
          prop="updateUser"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          :sortable="true"
          align="center"
          header-align="center"
          label="修改时间"
          min-width="155"
          prop="updateTime"
        ></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              @click="routerDetail(scope.row, (scope.row.canModify && scope.row.status == 1 ? 'edit' : 'view'))"
              type="text"
              v-if="hasBtnPermission('main_credit_punish_view')"
            >查看信用报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="pageIndex"
        :page-size="pageSize"
        :page-sizes="[pageSize, 20, 50, 100]"
        :total="total"
        @current-change="currentChangeHandle"
        @size-change="sizeChangeHandle"
        background
        layout="total, sizes, prev, pager, next"
        style="background-color:#FFF;margin-top:0;margin-right:0px;"
      ></el-pagination>
    </div>
  </div>
</template>
  
  <script>
import {
  getEntityInfoList,
  deleteIllegalData,
  commitIllegalData,
  getDownloadCount
} from "@/server/mainCredit.js";
import { mapState } from "vuex";
export default {
  name: "busWitnessTable",
  components: {},
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 227,
      dataListLoading: false,
      businessTypeNamelist: [],
      witnessStatuslist: [],
      form: {
        keywords: "",
        flowName: ""
      },
      downloadObj:{
        yearCount:0,
        count:0
      },
      statusFilters: [],
      subjectTypeFilters: [],
      punishTypeFilters: [],
      scopeTypeFilters: [],
      limitBehaviorFilters: [],
      filters: {},
      sortParams: {
        order: "",
        prop: ""
      },
      moreSearchItem: false,
      pageSize: 10, //每页条数
      pageIndex: 1, //当前页
      total: 0, //总条数
      tableData: [],
      multipleSelection: []
    };
  },
  props: {},
  filters: {},
  computed: {
    ...mapState({
      mainTypeList: state => state.dataDictionary.mainTypeList,
      publicScopeList: state => state.dataDictionary.publicScopeList,
      punishTypeList: state => state.dataDictionary.punishTypeList,
      punishLimitList: state => state.dataDictionary.punishLimitList
    })
  },
  watch: {
    mainTypeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.mainTypeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "subjectType_" + item.value
            });
          });
          this.subjectTypeFilters = filters;
        });
      }
    },
    publicScopeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.publicScopeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "subjectType_" + item.value
            });
          });
          this.scopeTypeFilters = filters;
        });
      }
    },
    punishTypeList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.punishTypeList.forEach(item => {
            filters.push({
              text: item.name,
              value: "punishType_" + item.value
            });
          });
          this.punishTypeFilters = filters;
        });
      }
    },
    punishLimitList: {
      immediate: true,
      deep: true, // 深度监听
      handler(val, newVal) {
        this.$nextTick(() => {
          let filters = [];
          this.punishLimitList.forEach(item => {
            filters.push({
              text: item.name,
              value: "limitBehaviorType_" + item.value
            });
          });
          this.limitBehaviorFilters = filters;
        });
      }
    }
  },
  created() {
    this.$store.dispatch("dataDictionary/getMainTypeList"); //获取主体类型
    this.$store.dispatch("dataDictionary/getPunishTypeList"); //获取处罚类型数据
    this.$store.dispatch("dataDictionary/getMainRevokeAttList"); // 获取撤销附件配置项数据
    this.$store.dispatch("dataDictionary/getPublicScopeList"); // 获取公开范围
    this.$store.dispatch("dataDictionary/getPunishLimitList"); // 获取限制的行为字典
    this.getStatusList();
  },
  activated() {
    // this.refresh();
  },

  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
    that.ifmove();
    this.getDataList();
    this.getYearOrHistoryDownload();
  },
  methods: {
    selectAll(selection) {
      if (selection.length == 0) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // 判断表格行是否可选
    checkSelectable(row, index) {
      /**
       * row：当前行数据
       * index：当前第几位
       */
      let flag = true;
      if (
        row.status == 1 &&
        row.canModify &&
        this.hasBtnPermission("main_credit_punish_delete")
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    filterPublic(value, row) {
      let flag;
      if (value == "subjectType_2") {
        flag = "政务公开";
      } else {
        flag = "社会公开";
      }
      return row.scopeTypeName === flag;
    },
    computeBtnLenth(item) {
      if (this.hasBtnPermission("main_credit_exposal_commit")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_add")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_delete")) {
        item.btnLength = 1;
      } else if (this.hasBtnPermission("main_credit_exposal_revoke")) {
        item.btnLength = 1;
      } else {
        item.btnLength = 0;
      }

      return item.btnLength;
    },
    dialogCancle() {
      this.moreSearchItem = false;
    },
    ifmove() {
      let tableMaxHeight = document.documentElement.clientHeight - 227;
      this.pageSize = parseInt(tableMaxHeight / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
      // this.getDataList()
    },

    formatterStatusClass(historyId) {
      switch (historyId) {
        case 2:
          return "icon-point icon-point-verificationing";
          break;
        case 1 || 5 || 6 || 7:
          return "icon-point icon-point-success";
          break;
        case 3:
          return "icon-point icon-point-info";
          break;
        default:
          return "";
          break;
      }
    },
    formatterStatusName(status) {
      switch (status) {
        case -1:
          return "待提交";
          break;
        case 0:
          return "核验中";
          break;
        case 1:
          return "正常";
          break;
        case 2:
          return "暂停";
          break;
        case 3:
          return "部分暂停";
          break;
        case 4:
          return "核验不通过";
          break;
        case 5:
          return "正常（有变更待提交）";
          break;
        case 6:
          return "正常（有变更核验中）";
          break;
        case 7:
          return "正常（有变更核验不通过）";
          break;
        default:
          return "--";
          break;
      }
    },
    getStatusList() {
      this.$httpReq.get("/complaint/listEnum/StatusEnum").then(res => {
        if (res.data.code === "1") {
          // { text: '待提交', value: 'status_1' },{ text: '资审澄清与修改文件', value: 'dataType_4' }
          let filters = [];
          res.data.data.forEach(item => {
            filters.push({
              text: item.name,
              value: "status_" + item.code
            });
          });
          this.statusFilters = filters;
        }
      });
    },

    // addNew() {
    //   removeTabHandle("credit_punish_detail");
    //   this.$router.push({
    //     name: "credit_punish_detail",
    //     query: {
    //       id: ""
    //     }
    //   });
    // },

    getDataList() {
      // 获取列表数据
      this.dataListLoading = true;
      getEntityInfoList({
        page: this.pageIndex,
        rows: this.pageSize,
        searchKey: this.form.keywords,
        orderBy:
          this.sortParams.prop && this.sortParams.order
            ? this.sortParams.prop +
              (this.sortParams.order == "ascending" ? " asc" : " desc")
            : "",
        filter: this.filters
      }).then(res => {
        this.tableData = res.data.rows;
        this.tableData.forEach(item => {
          // 提交注释
          // item.canModify=true;
          item.btnLength = this.computeBtnLenth(item);
        });
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading = false;
      });
    },
    getYearOrHistoryDownload() {
      getDownloadCount().then((res) => {
        if(res.data.code==1){
            this.downloadObj.yearCount=res.data.data.yearCount;
            this.downloadObj.count=res.data.data.count
        }
      });
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    filterChange(filters) {
      let filtersParams = {};
      for (var i in filters) {
        var filtersArr = filters[i];
        let key = "",
          value = [];
        filtersArr.length > 0 &&
          filtersArr.forEach(item => {
            key = item.split("_")[0];
            value.push(item.split("_")[1]);
          });
        key && value.length > 0
          ? (filtersParams[key] = value.toString())
          : null;
      }
      this.filters = filtersParams;
      this.getDataList();
    },
    sortChange(column, prop, order) {
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getDataList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //搜索按钮
    searchBtn() {
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.getDataList();
    },

    refresh() {
      //刷新按钮
      this.pageIndex = 1;
      this.moreSearchItem = false;
      this.form.keywords = "";
      this.form.datasetCode = "-1";
      this.form.witnessStatus = "-1";
      this.getDataList();
    },

    routerDetail(item, flag) {
      // 跳转详情

      if (flag == "edit"||flag =="view") {
        removeTabHandle("creditrReportDetail");
        this.$router.push({
          name: "creditrReportDetail",
          query: {
            id: item.id
          }
        });
      }
    },
    showRevokeForm(data) {
      this.$refs.revokeDiaRef.initDialog(data);
    },
    commitData(item) {
      this.$confirm(`确认提交吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        commitIllegalData({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "提交成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    },
    deleteById(item) {
      this.$confirm(
        `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        deleteIllegalData({
          id: item.id
        }).then(res => {
          if (res.data.code == "1") {
            this.$message({
              type: "success",
              message: "数据删除成功！"
            });
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        });
      });
    }

    // deleteSelectItem() {
    //   let ids = new Array();
    //   this.multipleSelection.forEach(key => {
    //     ids.push(key.id);
    //   });
    //   if (ids != "" || ids.length > 0) {
    //     this.$confirm(
    //       `<div style="text-align:center;font-size:16px">确认删除吗?<p style="font-size:12px">删除后的数据不可恢复</p></div>`,
    //       "提示",
    //       {
    //         dangerouslyUseHTMLString: true,
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning"
    //       }
    //     ).then(() => {
    //       deleteIllegalData({
    //         idList: ids
    //       }).then(res => {
    //         if (res.data.code == "1") {
    //           this.$message({
    //             type: "success",
    //             message: "数据删除成功！"
    //           });
    //           this.getDataList();
    //         } else {
    //           this.$message({
    //             type: "error",
    //             message: res.data.msg
    //           });
    //         }
    //       });
    //     });
    //   } else {
    //     this.$message({
    //       type: "error",
    //       message: "未选择删除项。"
    //     });
    //   }
    // }
  },

  destroyed() {
    window.onresize = null;
  }
};
</script>
<style lang="scss">

.search-content{
    .rightBoxInfo{
        .el-input .el-input__inner, .el-input--medium .el-input__inner, .el-input--suffix .el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            }
    .height_four{
        height: 40px;
    }
     .el-input--medium .el-input__inner{
            height: 40px;
            line-height: 40px;
        }
    }
 
}
</style>
  <style lang="scss" scoped>
.main_center {
    .content{
        background-color: #F5F5F5;
        padding:16px 24px;
    }
    .table-content{
        margin:0 0;
        width:100%;
    }
  .search-content {
    width: 100%; 
    // height: 64px;
    // position: relative;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding:24px;
     .pageTitle{
        font-size: 18px;
        font-weight: 600;
        color: #000000; 
        height: 40px; 
        line-height: normal;
        padding:0;
        margin-top:-9px;
    }
    .rightBoxInfo{
        width: calc(100% - 80px);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .searchBtn {
        height: 40px;
   margin-right: 10px;
    }
    .right_carousel {
      height: 40px;
      line-height: 40px;
   
      /deep/ .el-carousel__container {
        height: 40px;
      }
      .small_item {
        color: rgb(255, 204, 1);
        font-size: 20px;
        font-weight: 600;
      }
    }
  }
}
.search-content > div {
    padding: 0;
    height: auto;
    line-height:normal;
}
.btnBox {
  display: flex;
  flex-direction: column;

  .el-button {
    margin-left: 0px;
    margin-top: 10px;
  }
}
</style>
  